import React, {Component} from 'react';
import {connect} from 'react-redux';
import validators from './validators';
import validatorsPlantilla2 from './validatorsPlantilla2';
import DatePicker from 'react-datepicker';
import Modal from '../../../components/Modal';
import {fetchSituacion} from '../../../actions/MaestroGenerico';
import {clearSituaciones} from '../../../actions/MaestroGenerico';
//import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import Select from 'react-select';

import Autocomplete from 'react-autocomplete';
import moment from "moment/moment";
import {displayValidationErrors, isFormValid, resetValidators} from "../../../utils/validateForm";


const ANIO = moment().year();
const MES = moment().month() + 1;
const DIA = moment().date();


const DATE_INICIO_LOAD = moment(moment(`${DIA}/${MES}/${ANIO}`, 'DD/MM/YYYY'));


class SeleccionarSituacion extends Component {
    constructor(props, context) {
        super(props, context);
        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);

        if(this.props.tipoPlantilla==='2'){
            this.validators = validatorsPlantilla2;
            this.state = {
                value: '',
                fechaCarga: DATE_INICIO_LOAD,
                comentario: '',
                situacionId: '32',
                situacionNombre: '',
                verSituacion: false,
                items: [],
                isFormValided: false
            };
        }else{
            this.state = {
                value: '',
                fechaCarga: DATE_INICIO_LOAD,
                comentario: '',
                situacionId: '',
                situacionNombre: '',
                verSituacion: true,
                items: [],
                isFormValided: false
            };
            this.validators = validators;
        }

    }

    componentDidMount() {
        resetValidators(this.validators);
        this.handleFechaCarga(DATE_INICIO_LOAD);
        this.props.fetchSituacion('').then((result) => {
            if (result.payload.data.estadoTrama === '1') {
                var data = [];
                result.payload.data.itemList.forEach((item, index) => {
                    data.push({value:item.id,label:item.nombre})
                })
                this.setState({items:data});
            }
        });

    }

    validacionGrillaIntern(inicio) {
        if (!moment(inicio, 'DD/MM/YYYY', true).isValid()) {
            throw '¡La fecha es invalida, ingrese una valida, ejemplo:25/12/2017!';
        }

    }

    onChangeValue = e => {
        this.setState({[e.target.name]: e.target.value})
    }
    onChangeObservaciones = e => {
        this.onChangeValue(e);
        this.handleInputChange(e, 'comentario');
    }
    handleFechaCarga = date => {
        if (date !== null) {
            date['target'] = {value: date};
        }
        this.setState({fechaCarga: date});
        this.handleInputChange(date, 'fechaCarga');
    };

    handleInputChange = (e, field, exclude) => {
        const validator = this.validators[field];
        if(validator){
            validator.state = (e !== null && !exclude ? e.target.value : '');
            validator.exclude = (typeof(exclude) === 'undefined' || exclude === null ? false : exclude);
            this.onChangeFormValidation();
        }

    }

    validacionGrilla() {
        let fechaCarga = document.getElementById('fechaCarga').value;
        this.validacionGrillaIntern(fechaCarga);
        fechaCarga = moment(fechaCarga, 'DD/MM/YYYY').format("YYYY-MM-DD");
        return {fechaCarga};
    }

    onChangeFormValidation = () => {
        this.setState({isFormValided: isFormValid(this.validators)});
    }

    handleShow() {
        this.setState({show: true});
    }

    handleHide() {
        this.setState({show: false});
    }

    onChangeAndFilter = (e) =>{
        this.setState({situacionId: e.target.value});
        this.setState({'situacionId': e.target.value});
        this.handleInputChange(e, 'situacionId');
    }
    handleSituacion() {
        if (this.state.verSituacion === false) {
            return (<div/>);
        } else {

            return (
                <div className='row'>
                    <div className='col-md-10 mb-3 mt-2'>
                        <label className="labelInfo">Situación</label>
                        <select id="situacionId" name="situacionId" className='form-control' onChange={this.onChangeAndFilter} value={this.state.situacionId}>
                            <option value=''>Selecciona una situación</option>
                            {
                                this.state.items.map(item =>
                                    <option
                                        key={item.value}
                                        value={item.value}
                                    >
                                        {item.value}-{item.label}
                                    </option>
                                )
                            }
                        </select>
                        {displayValidationErrors(this.validators, 'situacionId')}
                    </div>
                </div>
            );
        }
    }

    render() {
        return (
            <div>
                <Modal idModal='seleccionar-situacion' modalSize='modal-dialog' title='Datos de Situación'
                       closeModal={this.props.closeModal}
                       isOpen
                >
                    <div className='steps-container fdvNew-slides'>
                        <div>
                            {
                                this.handleSituacion()
                            }

                            <div className='row'>
                                <div className='col-md-6 mb-3 mt-2'>
                                    <label className="labelInfo">Fecha Carga</label>
                                    <DatePicker name='fechaCarga'
                                                selected={this.state.fechaCarga}
                                                className='form-control fSearch-search date-picker ng-pristine ng-valid ng-isolate-scope ng-touched checkDeGrillaEnterCerrar'
                                                dateFormat='DD/MM/YYYY'
                                                locale='es'
                                                onChange={this.handleFechaCarga}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                        this.searchAll();
                                                    }
                                                }}
                                                id='fechaCarga'
                                                ref={(datepicker) => {
                                                    this.datepickerInicio = datepicker;
                                                }}
                                    />
                                    {displayValidationErrors(this.validators, 'fechaCarga')}
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12 mb-3 mt-2'>
                                    <label className='labelInfo'>Observaciones
                                    </label>
                                    <textarea name='comentario'
                                              className='form-control' value={this.state.comentario}
                                              onChange={this.onChangeObservaciones}
                                              placeholder='Ingresa tus comentarios acá'
                                    />
                                </div>
                            </div>
                            <div className='modal-actions'>
                                <button className='btn btn-primary pull-right'
                                        onClick={() => {
                                            if (this.state.isFormValided) {
                                                var data = this.validacionGrilla();
                                                this.props.procesarSituacion(
                                                    {
                                                        comentario: this.state.comentario,
                                                        fechaCarga: data.fechaCarga,
                                                        situacionId: this.state.situacionId
                                                    }
                                                )
                                            }
                                            this.onChangeFormValidation();
                                        }}>Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        items: state.items,

    };
}


SeleccionarSituacion.defaultProps = {
    items: [],
};
export default connect(mapStateToProps,
    {
        fetchSituacion,
        clearSituaciones
    })(SeleccionarSituacion);



// WEBPACK FOOTER //
// ./src/pages/modals/SeleccionarSituacion/index.js